import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/auth/AuthContext';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { authLoading, user } = useAuth();

  if (authLoading) {
    return (
      <div className="flex h-64 w-full items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  if (!user) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }

  return children;
};

export default ProtectedRoute;
